import { MAX_RECRUITMENT_SOURCE_NAME_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";
import { useMemo } from "react";

export const useGetRecruitmentSourceSchema = () => {
  const recruitmentSourceSchema = useMemo(() => {
    return validator.object().shape({
      recruitmentSourceName: validator
        .string()
        .trim()
        .emptyToNull()
        .max(MAX_RECRUITMENT_SOURCE_NAME_INPUT_VALIDATION)
        .label("求人獲得ルート名")
        .required(),
    });
  }, []);

  return { recruitmentSourceSchema }
}
